import axios from "axios";

export const getPrograms = async (userUuid, products, eportfolioToken) => {
  // Check Eportfolio exists
  let api_url;

  products.forEach((value) => {
    if (value.sp_slug === "eportfolio") {
      api_url = value.api_url;
    }
  });

  if (api_url === undefined) {
    return false;
  } else {
    try {
      const token = eportfolioToken

      if (!token) {
        return false;
      }

      const apiToken = token;

      let myportfolioConfig = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${api_url}api/v1/completedMemberPrograms/get`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiToken}`,
        },
        data: {
          user_uuid: userUuid,
        },
      };
      try {
        const completedPrograms = await axios.request(myportfolioConfig);
        if (completedPrograms.data.status === 404) {
          return false;
        }
        const programData = completedPrograms?.data?.data.member_programs ?? [];
        return programData;
      } catch (err) {
        return [];
      }
    } catch (err) {
      console.log(err);
      return [];
    }
  }
};
